const features = [
  {
    icon: 'ri-download-cloud-2-line',
    title: '海量韩漫资源',
    desc: '覆盖3000+韩漫作品，从热门连载到经典完结，分类齐全一站搞定韩漫下载。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台兼容',
    desc: '支持安卓、iOS多平台韩漫APK下载安装，适配手机与平板，随时随地阅读。',
  },
  {
    icon: 'ri-wifi-off-line',
    title: '真离线阅读',
    desc: '下载后无需联网即可畅读韩漫全集，地铁、飞机、户外都能享受流畅阅读体验。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速更新同步',
    desc: '与韩漫官方同步更新，汉化版本第一时间推送，追更党不会再错过任何一话。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠推荐',
    desc: '所有韩漫APK经过安全筛查，拒绝恶意广告与捆绑软件，保障你的手机安全。',
  },
];

export default function Features() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            为什么韩漫爱好者都选择韩漫之家
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-primary-200 transition-all duration-300 text-center cursor-default"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100/80 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}